<template>
  <svg
    id="ROARLogo-short"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 488.5 431.9"
    style="enable-background: new 0 0 488.5 431.9"
    xml:space="preserve"
  >
    <g id="ROARLogo-Icon">
      <path
        class="st0"
        d="M281.2,246c-0.4-5-0.9-9.7-1.3-14.4c-0.5-7.8-1-15.6-1.5-23.4c-0.2-2.8-0.3-5.6-0.6-8.4
			c-0.5-5.4-1-10.8-1.4-16.2c-0.4-5.7-0.6-11.3-1-17c-0.6-7.8-1.4-15.5-2-23.3c-0.6-7.8-1-15.6-1.5-23.4c-0.2-2.5-0.3-4.9-0.5-7.4
			c-0.6-8.3-1.3-16.7-1.9-25c-0.2-2.8-0.3-5.6-0.6-8.4c-0.5-6.1-0.9-12.3-1.4-18.4c-0.2-3.2-0.4-6.4-0.6-9.6
			c-0.4-5.3-0.9-10.6-1.4-15.9c-0.5-5.1-0.5-10.2-1.5-15.2c-2.7-13.3-10-19-22.8-19c-57.9,0-115.8-0.2-173.6-0.3
			c-16,0-31.9-0.1-47.9-0.1c-5.9,0-11,1.6-14.2,6.8c-4,6.5-4.6,13.9-4.8,21.3c-0.1,2.5,0.7,5,0.9,7.5c0.7,9.2,1.4,18.4,2,27.6
			c0.5,6.6,1,13.3,1.5,19.9c0.5,6.8,1,13.6,1.5,20.4c0.5,6.8,1,13.6,1.5,20.4c0.5,6.6,1,13.3,1.5,19.9c0.5,6.6,1,13.1,1.5,19.7
			c0.5,8,1,16.1,1.5,24.1c0.2,2.5,0.3,5.1,0.5,7.6c0.6,7.5,1.4,15,2,22.6c0.5,6.5,1,12.9,1.5,19.4c0.6,8.3,0.9,16.6,1.6,24.9
			c0.4,5.2,2.3,8.6,7.4,9.7c2.6,0.6,5.3,1,8,1c148.2,0,296.4,0,444.6,0c0.9,0,1.8,0,2.7,0c4.7-0.1,7.4-2.8,7.5-7.4c0-3.7,0-7.3,0-11
			c0-6.7-2.3-9-8.9-9c-65,0-130.1,0-195.1,0C283.1,246,282.1,246,281.2,246z M307.5,16.9c-1,0-1.5,0-2,0c-7.5-0.6-12.7,4.4-12.7,12.6
			c0,11.2-0.3,22.4-0.5,33.6c-0.2,11.9-0.3,23.9-0.5,35.8c-0.2,12-0.3,24.1-0.5,36.1c-0.2,11.9-0.3,23.7-0.5,35.6
			c-0.2,11.4-0.4,22.9-0.5,34.3c-0.1,8.6,0,17.3,0,25.9c0,3.6,2.6,6.3,6.3,6.7c4.4,0.5,7.5-1.3,8.1-5.1c0.6-4.3,0.7-8.7,1.1-13
			c0.5-6.3,1-12.6,1.5-18.9c0.2-2.7,0.3-5.4,0.5-8.1c0.6-7.4,1.4-14.7,2-22.1c0.4-5.6,0.6-11.2,1-16.7c0.6-7.7,1.4-15.4,2-23.1
			c0.5-6.5,1-12.9,1.5-19.4c0.5-7.9,1-15.8,1.5-23.7c0.2-2.5,0.3-5.1,0.5-7.6c0.5-5.4,1.1-10.8,1.5-16.2c0.4-5.3,0.6-10.7,1-16
			c0.5-7.3,1-14.6,1.5-21.9c0.2-3.1-1.1-5.1-3.6-6.8C313.7,16.8,310.4,16.8,307.5,16.9z M401.2,61.2c-0.7-1.7-1.1-3.8-2.3-5
			c-1.8-1.8-4-3.4-6.4-4.4c-7-2.9-13.1-2.1-15.6,5.9c-2.2,7.3-5.2,14.3-7.9,21.4c-3.6,9.5-7.2,18.9-10.7,28.4
			c-3.6,9.6-7,19.3-10.5,28.9c-3.1,8.3-6.4,16.6-9.4,25c-3.6,9.7-7,19.4-10.6,29.1c-2.8,7.8-5.7,15.5-8.6,23.3
			c-1.8,4.9-3.6,9.8-5.6,14.6c-1.7,4.1-0.5,7.6,3.7,9.7c3.1,1.5,6.6,0,8.4-3.8c1.9-4.1,3.7-8.3,5.5-12.5c5.6-12.8,11.3-25.7,17-38.5
			c6-13.5,11.9-27,17.9-40.5c5.7-12.9,11.3-25.8,17-38.7c5.4-12.3,10.9-24.6,16.3-36.9C400.1,65.3,400.5,63.4,401.2,61.2z M448,122.3
			c0.6-2.9-1.2-4.9-2.9-6.7c-4.2-4.3-9.4-5.9-13.7,0.2c-1.9,2.7-4.2,5.1-6.3,7.7c-11.5,14-22.9,27.9-34.4,41.9
			c-13,15.8-26,31.6-39,47.5c-5.1,6.3-10.3,12.5-15.4,18.8c-1.6,1.9-1.6,4.1-0.6,6.2c2,4.4,6.3,4.9,10,0.9
			c9.6-10.5,19.1-21.1,28.6-31.6c13-14.3,25.9-28.7,38.9-43c10.9-12,21.7-24,32.6-36C447.3,126.5,448.5,124.8,448,122.3z M362.6,243
			c0.1,0,1-0.1,1.7-0.4c20-6,40-12,60-18.1c13.7-4.1,27.4-8.3,41.1-12.6c1.3-0.4,2.7-1.9,3.1-3.2c1.5-4.6-0.7-8.6-3-12.3
			c-1.6-2.5-3.6-3-6.5-1.9c-14.8,5.7-29.5,11.5-44.3,17.2c-15.2,5.9-30.4,11.9-45.6,17.8c-3,1.2-5.9,2.4-8.8,3.7
			c-2.5,1.1-3.9,3.6-3.4,5.7C357.3,241.4,359.3,243,362.6,243z"
      />
      <path
        class="st1"
        d="M281.2,246c1,0,1.9,0,2.9,0c65,0,130.1,0,195.1,0c6.6,0,8.9,2.3,8.9,9c0,3.7,0,7.3,0,11
			c-0.1,4.7-2.8,7.4-7.5,7.4c-0.9,0-1.8,0-2.7,0c-148.2,0-296.4,0-444.6,0c-2.7,0-5.4-0.4-8-1c-5.1-1.2-7-4.5-7.4-9.7
			c-0.7-8.3-1-16.6-1.6-24.9c-0.4-6.5-0.9-12.9-1.5-19.4c-0.6-7.5-1.3-15-2-22.6c-0.2-2.5-0.4-5.1-0.5-7.6c-0.5-8-1-16.1-1.5-24.1
			c-0.4-6.6-1-13.1-1.5-19.7c-0.5-6.6-1-13.3-1.5-19.9c-0.5-6.8-1-13.6-1.5-20.4c-0.5-6.8-1-13.6-1.5-20.4c-0.5-6.6-1-13.3-1.5-19.9
			c-0.7-9.2-1.3-18.4-2-27.6c-0.2-2.5-1-5-0.9-7.5c0.2-7.4,0.8-14.8,4.8-21.3c3.2-5.2,8.3-6.9,14.2-6.8c16,0.1,31.9,0.1,47.9,0.1
			C125.2,0.7,183.1,0.9,241,0.9c12.9,0,20.1,5.7,22.8,19c1,5,1.1,10.1,1.5,15.2c0.5,5.3,1,10.6,1.4,15.9c0.3,3.2,0.4,6.4,0.6,9.6
			c0.5,6.1,0.9,12.3,1.4,18.4c0.2,2.8,0.3,5.6,0.6,8.4c0.6,8.3,1.3,16.7,1.9,25c0.2,2.5,0.4,4.9,0.5,7.4c0.5,7.8,0.9,15.6,1.5,23.4
			c0.6,7.8,1.4,15.5,2,23.3c0.4,5.7,0.6,11.3,1,17c0.4,5.4,1,10.8,1.4,16.2c0.2,2.8,0.4,5.6,0.6,8.4c0.5,7.8,0.9,15.6,1.5,23.4
			C280.2,236.3,280.7,240.9,281.2,246z"
      />
      <path
        class="st1"
        d="M307.5,16.9c2.9-0.1,6.2,0,9.2,2c2.5,1.7,3.8,3.7,3.6,6.8c-0.5,7.3-1,14.6-1.5,21.9c-0.3,5.3-0.6,10.7-1,16
			c-0.4,5.4-1,10.8-1.5,16.2c-0.2,2.5-0.4,5.1-0.5,7.6c-0.5,7.9-1,15.8-1.5,23.7c-0.4,6.5-0.9,12.9-1.5,19.4
			c-0.6,7.7-1.4,15.4-2,23.1c-0.4,5.6-0.6,11.2-1,16.7c-0.6,7.4-1.3,14.7-2,22.1c-0.2,2.7-0.3,5.4-0.5,8.1c-0.5,6.3-1,12.6-1.5,18.9
			c-0.3,4.3-0.4,8.7-1.1,13c-0.6,3.8-3.6,5.6-8.1,5.1c-3.7-0.4-6.3-3.1-6.3-6.7c0-8.6-0.1-17.3,0-25.9c0.1-11.4,0.3-22.9,0.5-34.3
			c0.2-11.9,0.3-23.7,0.5-35.6c0.2-12,0.3-24.1,0.5-36.1c0.2-11.9,0.3-23.9,0.5-35.8c0.2-11.2,0.4-22.4,0.5-33.6
			c0-8.2,5.3-13.1,12.7-12.6C306,16.9,306.5,16.9,307.5,16.9z"
      />
      <path
        class="st1"
        d="M401.2,61.2c-0.7,2.2-1.1,4.2-1.8,6c-5.4,12.3-10.8,24.6-16.3,36.9c-5.7,12.9-11.3,25.8-17,38.7
			c-5.9,13.5-11.9,27-17.9,40.5c-5.7,12.8-11.3,25.7-17,38.5c-1.8,4.2-3.6,8.3-5.5,12.5c-1.7,3.8-5.3,5.3-8.4,3.8
			c-4.3-2.1-5.5-5.5-3.7-9.7c2-4.8,3.7-9.7,5.6-14.6c2.9-7.7,5.7-15.5,8.6-23.3c3.5-9.7,7-19.4,10.6-29.1c3.1-8.3,6.4-16.6,9.4-25
			c3.6-9.6,7-19.3,10.5-28.9c3.5-9.5,7.2-19,10.7-28.4c2.7-7.1,5.7-14.1,7.9-21.4c2.4-8,8.6-8.8,15.6-5.9c2.3,1,4.6,2.6,6.4,4.4
			C400.1,57.4,400.5,59.5,401.2,61.2z"
      />
      <path
        class="st1"
        d="M448,122.3c0.5,2.4-0.7,4.1-2.2,5.8c-10.9,12-21.7,24-32.6,36c-13,14.3-25.9,28.7-38.9,43
			c-9.5,10.5-19,21.1-28.6,31.6c-3.6,4-7.9,3.4-10-0.9c-1-2.1-1-4.3,0.6-6.2c5.1-6.3,10.3-12.5,15.4-18.8c13-15.8,26-31.6,39-47.5
			c11.5-14,22.9-27.9,34.4-41.9c2.1-2.5,4.4-5,6.3-7.7c4.2-6.1,9.5-4.5,13.7-0.2C446.8,117.5,448.6,119.5,448,122.3z"
      />
      <path
        class="st1"
        d="M362.6,243c-3.3,0-5.3-1.6-5.8-4c-0.5-2.1,0.9-4.6,3.4-5.7c2.9-1.3,5.9-2.5,8.8-3.7
			c15.2-6,30.4-11.9,45.6-17.8c14.8-5.7,29.5-11.5,44.3-17.2c2.9-1.1,4.9-0.6,6.5,1.9c2.4,3.7,4.5,7.7,3,12.3
			c-0.4,1.3-1.9,2.8-3.1,3.2c-13.7,4.3-27.4,8.4-41.1,12.6c-20,6-40,12.1-60,18.1C363.5,242.8,362.7,242.9,362.6,243z"
      />
    </g>
    <g id="ROARLogo-Text">
      <path
        class="st1"
        d="M27.1,423.2V290.3h31.3c12.6,0,22.7,3.3,30.1,10s11.1,15.7,11.1,27c0,7.7-1.8,14.4-5.5,20.1
			c-3.6,5.6-8.9,9.9-15.6,12.7c4,2.8,7.9,6.6,11.7,11.4c3.8,4.8,9.2,13.2,16.1,25.2c4.4,7.5,7.8,13.2,10.5,17l6.6,9.5h-21.3l-5.4-8.8
			c-0.2-0.3-0.5-0.9-1.1-1.6l-3.5-5.2l-5.5-9.7l-6-10.4c-3.7-5.5-7.1-9.8-10.1-13c-3.1-3.2-5.8-5.6-8.3-7c-2.5-1.4-6.6-2.1-12.5-2.1
			H45v57.8H27.1z M50.3,306.5H45v41.9h6.8c9.1,0,15.3-0.8,18.6-2.5c3.4-1.6,6-4.1,7.9-7.5c1.9-3.3,2.8-7.1,2.8-11.4
			c0-4.2-1-8-3.1-11.4c-2.1-3.4-5-5.8-8.8-7.2C65.4,307.2,59.1,306.5,50.3,306.5z"
      />
      <path
        class="st1"
        d="M309.5,289.5H322l56,133.6h-18.3l-16.6-39.4h-53.3l-15.6,39.4h-18.4L309.5,289.5z M335.7,366.9l-20.2-48.1
			l-18.7,48.1H335.7z"
      />
      <path
        class="st1"
        d="M392.2,423.2V290.3h31.3c12.6,0,22.7,3.3,30.1,10c7.4,6.7,11.1,15.7,11.1,27c0,7.7-1.8,14.4-5.5,20.1
			c-3.6,5.6-8.9,9.9-15.6,12.7c4,2.8,7.9,6.6,11.7,11.4c3.8,4.8,9.2,13.2,16.1,25.2c4.4,7.5,7.8,13.2,10.5,17l6.6,9.5h-21.3l-5.4-8.8
			c-0.2-0.3-0.5-0.9-1.1-1.6l-3.5-5.2l-5.5-9.7l-6-10.4c-3.7-5.5-7.1-9.8-10.1-13c-3.1-3.2-5.8-5.6-8.3-7c-2.5-1.4-6.6-2.1-12.5-2.1
			h-4.7v57.8H392.2z M415.5,306.5h-5.4v41.9h6.8c9.1,0,15.3-0.8,18.6-2.5c3.4-1.6,6-4.1,7.9-7.5c1.9-3.3,2.8-7.1,2.8-11.4
			c0-4.2-1-8-3.1-11.4c-2.1-3.4-5-5.8-8.8-7.2C430.5,307.2,424.3,306.5,415.5,306.5z"
      />
      <path
        class="st1"
        d="M254.5,349.5c0,4.7,0.4,9.4-0.1,14c-0.9,9.4-3.3,18.4-8.1,26.6c-6.4,11-15.1,19.6-26.4,25.6
			c-7.2,3.9-14.9,6.2-23,7.2c-3.5,0.4-7,1-10.5,1c-16-0.3-30.7-5-42.8-15.7c-10.9-9.6-18.4-21.5-21.1-36c-1.1-5.8-2-11.7-1.9-17.5
			c0.3-16.3,4.8-31.4,15.3-44.2c9.7-11.8,22-19.8,37.1-22.4c6.9-1.2,14.1-1.6,21-1c18.3,1.4,33.6,9.2,45.5,23.5
			c6.9,8.3,11.4,17.7,13.5,28.2c0.7,3.5,1.3,7.1,1.9,10.6C254.8,349.5,254.7,349.5,254.5,349.5z M189.6,375.1c-0.6,1.8,0.2,3,2,3.2
			c2.9,0.2,5.8,0.2,8.7,0.1c2.4-0.1,4.4-1.1,5.6-3.2c1.7-3.1,3.4-6.3,4.5-9.7c3-9.7,3.6-19.6,1.7-29.6c-1-5.4-5.4-10.3-10.7-11.6
			c-8-2-16.1-2.1-24.2-1c-12.5,1.8-15.6,8.1-16.5,17.5c-1,10.4,0.5,20.6,5,30.1c1.4,3,2.7,6.3,6.5,7.3c4,1.1,7.9,0.8,11.8-0.7
			c0-0.9,0-1.7,0-2.3c-1.5-0.5-2.8-0.9-4.1-1.4c-1.5-0.6-3.7-1-3.1-3.1c0.7-2.4,3-1.4,4.7-1.2c0.2,0,0.5,0.2,0.7,0.3
			c2.5,0.2,5,0.5,7.5,0.5c1.7,0,3.3-0.8,5-0.9c0.8,0,1.6,0.7,2.3,1.2c-0.5,0.9-0.8,2.3-1.6,2.6C193.6,374.1,191.6,374.5,189.6,375.1z
			 M175,384c6.8,9.4,17.3,9.4,23.9-0.1c-3.1-0.5-6.4-1-9.7-1.5c-1-0.2-2.1-0.7-3-0.5C182.4,382.4,178.6,383.3,175,384z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ROARLogoShort',
};
</script>

<style scoped>
.st0 {
  fill: #ffffff;
}
.st1 {
  fill: #231f20;
}
</style>
